import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { logError } from "@faire/web--source/common/logging";
import { trackInfraWebMemoryUsage } from "@faire/web-api--source/events/infra/actionUnknown/webMemoryUsage";
import * as Bowser from "bowser";
import { useEffect } from "react";
var MILLIS_1_MIN = 1000 * 60;
var MILLIS_5_MINS = 5 * MILLIS_1_MIN;
var useMemoryMonitor = function(app_id) {
    var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MILLIS_5_MINS;
    return useEffect(function() {
        var _getWindow;
        var performance1 = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.performance;
        if (!(performance1 === null || performance1 === void 0 ? void 0 : performance1.memory)) {
            return;
        }
        var measureMemory = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _getWindow, memory, userAgent, browser, _browser_getBrowserName, _browser_getBrowserVersion, _browser_getOSName, _browser_getOSVersion, _browser_getPlatformType;
                return _ts_generator(this, function(_state) {
                    try {
                        ;
                        memory = performance1.memory;
                        userAgent = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.navigator.userAgent;
                        browser = userAgent ? Bowser.getParser(userAgent) : null;
                        ;
                        trackInfraWebMemoryUsage((_browser_getBrowserName = browser === null || browser === void 0 ? void 0 : browser.getBrowserName()) !== null && _browser_getBrowserName !== void 0 ? _browser_getBrowserName : "unknown", (_browser_getBrowserVersion = browser === null || browser === void 0 ? void 0 : browser.getBrowserVersion()) !== null && _browser_getBrowserVersion !== void 0 ? _browser_getBrowserVersion : "unknown", (_browser_getOSName = browser === null || browser === void 0 ? void 0 : browser.getOSName()) !== null && _browser_getOSName !== void 0 ? _browser_getOSName : "unknown", (_browser_getOSVersion = browser === null || browser === void 0 ? void 0 : browser.getOSVersion()) !== null && _browser_getOSVersion !== void 0 ? _browser_getOSVersion : "unknown", (_browser_getPlatformType = browser === null || browser === void 0 ? void 0 : browser.getPlatformType()) !== null && _browser_getPlatformType !== void 0 ? _browser_getPlatformType : "unknown", "".concat(memory.jsHeapSizeLimit), "".concat(memory.totalJSHeapSize), "".concat(memory.usedJSHeapSize), "".concat(getRoundedSessionTime()), app_id);
                    } catch (error) {
                        logError(error);
                    }
                    return [
                        2
                    ];
                });
            });
            return function measureMemory() {
                return _ref.apply(this, arguments);
            };
        }();
        var intervalId = setInterval(measureMemory, interval);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        app_id,
        interval
    ]);
};
function getRoundedSessionTime() {
    var roundedMinutes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
    var timeInMilliseconds = performance.now();
    var timeInMinutes = timeInMilliseconds / MILLIS_1_MIN;
    var roundedTime = Math.round(timeInMinutes / roundedMinutes) * roundedMinutes;
    return roundedTime;
}
export default useMemoryMonitor;
